import { Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import * as yup from 'yup';
import { Medication } from '../../store/patientsSlice.ts';
import { MedicationEdition } from '../ui/DaliaComponents.tsx';
import { PatientCompleteWizardType } from '../ui/WizardStep.tsx';

const PatientCompleteWizardStep3: PatientCompleteWizardType = ({ formik }) => {
  const onMedicationsChange = (medications: Medication[]) => {
    void formik.setFieldValue('medications', medications);
  };

  return (
    <>
      <Grid alignItems="flex-start" container spacing={3}>
        <Grid offset={1} size={3}>
          <Typography>Comorbidités</Typography>
        </Grid>
        <Grid size={8}>
          <Stack>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formik.values.comorbidities?.comorbiditySleepApnea}
                  name="comorbiditySleepApnea"
                  onChange={() => formik.setFieldValue('comorbidities.comorbiditySleepApnea', !formik.values.comorbidities?.comorbiditySleepApnea)}
                />
              }
              label="Apnée du sommeil"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formik.values.comorbidities?.comorbidityCardiovascular}
                  name="comorbidityCardiovascular"
                  onChange={() => formik.setFieldValue('comorbidities.comorbidityCardiovascular', !formik.values.comorbidities?.comorbidityCardiovascular)}
                />
              }
              label="Maladies cardiovasculaires"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formik.values.comorbidities?.comorbidityAnxiety}
                  name="comorbidityAnxiety"
                  onChange={() => formik.setFieldValue('comorbidities.comorbidityAnxiety', !formik.values.comorbidities?.comorbidityAnxiety)}
                />
              }
              label="Anxiété"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formik.values.comorbidities?.comorbidityNeurological}
                  name="comorbidityNeurological"
                  onChange={() => formik.setFieldValue('comorbidities.comorbidityNeurological', !formik.values.comorbidities?.comorbidityNeurological)}
                />
              }
              label="Maladies neurologiques"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formik.values.comorbidities?.comorbidityEndocrine}
                  name="comorbidityEndocrine"
                  onChange={() => formik.setFieldValue('comorbidities.comorbidityEndocrine', !formik.values.comorbidities?.comorbidityEndocrine)}
                />
              }
              label="Troubles endocriniens"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formik.values.comorbidities?.comorbidityOther}
                  name="comorbidityOther"
                  onChange={() => formik.setFieldValue('comorbidities.comorbidityOther', !formik.values.comorbidities?.comorbidityOther)}
                />
              }
              label="Autres"
            />
          </Stack>
        </Grid>
        <Grid offset={1} size={3}>
          <Typography>Traitements médicamenteux en cours (tous types de traitements confondus)</Typography>
        </Grid>
        <Grid size={8}>
          <MedicationEdition medications={formik.values.medications ?? []} onMedicationsChange={onMedicationsChange} />
        </Grid>
      </Grid>
    </>
  );
};

PatientCompleteWizardStep3.label = 'Caractéristiques cliniques';

PatientCompleteWizardStep3.initialValues = {
  comorbidities: {
    comorbiditySleepApnea: false,
    comorbidityCardiovascular: false,
    comorbidityAnxiety: false,
    comorbidityNeurological: false,
    comorbidityEndocrine: false,
    comorbidityOther: false,
  },
  medications: [],
};

PatientCompleteWizardStep3.validationSchema = yup.object().shape({
  medications: yup.array().of(
    yup.object().shape({
      startDate: yup.string().required('La date de début est requise'),
      name: yup.string().required('Le nom du médicament est requis'),
      quantity: yup.number().required('La quantité est requise'),
      unit: yup.string().required("L'unité est requise"),
      frequency: yup.string().required('La fréquence est requise'),
    }),
  ),
});

export default PatientCompleteWizardStep3;
